import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import { IModalSlice, useLayoutSelector } from '../../redux';
import { ModalBuy } from '../ModalBuy';
import { ModalChangeNameOverlay } from '../ModalChangeNameOverlay';
import { ModalNews } from '../ModalNews';
import { ModalOffer } from '../ModalOffer';
import { ModalSkills } from '../ModalSkills';
import { OpenCase } from '../OpenCase';
import { OpenCaseReward } from '../OpenCaseReward';

const MODAL_COMPONENTS: Partial<
	Record<keyof IModalSlice, () => JSX.Element | null>
> = {
	modalNewsVisible: ModalNews,
	modalOfferVisible: ModalOffer,
	// modalCaseDefaultVisible: ModalCaseDefault,
	// modalCaseKitVisible: ModalCaseKit,
	openCaseVisible: OpenCase,
	openCaseRewardVisible: OpenCaseReward,
	modalSkillsVisible: ModalSkills,
	modalBuyVisible: ModalBuy,
};

const Modals = () => {
	const modals = useLayoutSelector((state) => state.modal);

	return (
		<Fragment>
			<ModalChangeNameOverlay />
			{Object.entries(MODAL_COMPONENTS).map(([key, Component]) => (
				<CSSTransition
					key={key}
					in={!!modals[key as keyof IModalSlice]}
					timeout={500}
					classNames="modal"
					unmountOnExit
				>
					<Component />
				</CSSTransition>
			))}
		</Fragment>
	);
};

export { Modals };
